import { Card, Spinner } from 'react-bootstrap';

function ProvinceSubmissionsCard({ loading, provinceData, title = 'Submissions by Province' }) {
  return (
    <Card className="dashboard-card border-0 h-100">
      <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
        <h6 className="mb-0 fw-semibold">
          <i className="bi bi-map me-2 text-primary"></i>{title}
        </h6>
      </Card.Header>
      <Card.Body className="pt-2">
        {loading ? (
          <div className="text-center py-4"><Spinner animation="border" size="sm" /></div>
        ) : provinceData.length === 0 ? (
          <p className="text-muted text-center py-4 mb-0 small">No province data available.</p>
        ) : (
          <div style={{ overflowY: 'auto', maxHeight: '260px' }}>
            {provinceData.map(p => (
              <div key={p.name} className="d-flex justify-content-between align-items-center px-2 py-2 border-bottom">
                <small className="text-truncate" style={{ maxWidth: '75%' }}>{p.name}</small>
                <span
                  className="badge rounded-pill"
                  style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', minWidth: '52px', textAlign: 'center' }}
                >
                  {p.count.toLocaleString()}
                </span>
              </div>
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProvinceSubmissionsCard;
